import { Drawer } from 'antd';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    padding: 0 !important;
  }
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: grid;
  grid-template-rows: 72px calc(100% - 72px);
  overflow: hidden;
`;

export const Header = styled.div`
  padding: 24px 24px 0;
  overflow: hidden;
  border-bottom: 1px solid ${COLORS.systemDark100};
`;

export const Body = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow: scroll;

  .text-areas {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .post-scriptum {
    font-size: 12px;
    color: ${COLORS.systemDark200};
    text-align: center;
  }
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  .description {
    color: ${COLORS.systemDark200};
    font-size: 14px;
  }
`;
